import { DAY_IN_MINS, HOUR_IN_MINS } from '../shipments/constants';
export function truncNum(num) {
    var partialResult = Math.trunc(num);
    return partialResult === -0 ? Math.abs(partialResult) : partialResult;
}
export function calcDeltaEta(etaMinutes) {
    if (etaMinutes === void 0) { etaMinutes = null; }
    if (etaMinutes === null)
        return null;
    var days = truncNum(etaMinutes / DAY_IN_MINS);
    var hours = truncNum((etaMinutes - days * DAY_IN_MINS) / HOUR_IN_MINS);
    var mins = etaMinutes - hours * HOUR_IN_MINS - days * DAY_IN_MINS;
    return {
        days: days,
        hours: hours,
        mins: mins,
    };
}
